/**
 * Modalify
 * Wrapper for dynamicly injecting modal alerts into the DOM
 * @author Martin Hansen <martin.hansen@valtech.com>
 */

// # Imports
import { Modal } from 'bootstrap.native';

// # Class
export class Modalify {
    constructor(element) {
        element.Modalify = this;

        this._refs = {
            el: element
        };

        this._props = { ...this.props, ...element.dataset };

        //this._refs.el.setAttribute('onclick', 'return false');
        this._refs.el.setAttribute('data-target', '#' + this._props.id);

        // # Events
        this._refs.el.addEventListener('click', this._onElementClick.bind(this));
    }

    /**   
     * @description Handler for interaction with user click
     * @param {Event} e - Event
     */
    _onElementClick(e) {
        e.preventDefault();

        // Injet corrosponding modal into the DOM 
        document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', this.template);

        // Save ref
        this._refs.modal = document.querySelector('#' + this._props.id);

        // Instanciate Model handling
        const oModal = new Modal(this._refs.el);
        oModal.show();

        const resolve = () => {
            oModal.hide();

            const href = this._refs.el.getAttribute('href');

            // Detech callback or ordinary href? 
            if (href.includes('__doPostBack')) { // Webforms
                const pb = href.replace('javascript:__doPostBack(', '').replace(/'/g, '').replace(/,/g, '').replace(')', '');
                __doPostBack(pb, '');
            } else { // Orindary
                window.location.href = window.location.pathname + href;
            }

            return true;
        };

        // # Event mangement
        if(this._refs.modal) {
            this._refs.modal.addEventListener('shown.bs.modal', (event) => {
                let x = event.target,
                    trigger = x.querySelector('.btn-primary');
    
                trigger.addEventListener('click', resolve);
            }, false);
    
            this._refs.modal.addEventListener('hidden.bs.modal', (event) => {
                let x = event.target, trigger = x.querySelector('.btn-primary');
    
                trigger.removeEventListener('click', resolve);
    
                x.parentNode.removeChild(x);
            }, false);
        }
    }

    /**
     * @description Template containing default fields for Modal
     * @returns {Literal} - Template literal
     */
    get template() {
        return `
            <div id="${this._props.id}" class="modal fade" role="dialog" aria-labelledby="Dismissable alert" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                    <div class="modal-body">
                        ${this._props.modalifyText}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn-secondary" data-dismiss="modal">${this._props.modalifyCancel}</button>
                        <button type="button" class="btn-primary">${this._props.modalifyOk}</button>
                    </div>
                    </div>
                </div>
            </div>
        `;
    }

    /**
     * @description Properties for feature
     * @returns {Object} - Default property values
     */
    get props() {
        return {
            'id': this._refs.el.id + '-overlay',
            'modalifyText': 'The saved card will be removed permenently.',
            'modalifyOk': 'OK',
            'modalifyCancel': 'Cancel'
        }
    }
}